import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-dropdown-toggle"
}
const _hoisted_2 = { class: "as-dropdown-toggle__select" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "as-dropdown-toggle__select__as-body__search"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 2 }

import { computed, ref } from "vue";
import { useClickOutside } from "~src/utils/clickOutsideHelper";
import IconCustomArrownDown from "~src/components/icons/IconCustomArrownDown.vue";
import IconCustomArrownUp from "~src/components/icons/IconCustomArrownUp.vue";
import Loading from "./Loading.vue";
import NoData from "./NoData.vue";


const __default__ = {};

interface IProps {
  data: any[];
  idActive?: string | number;
  isFilterAll?: boolean;
  isSearchAll?: boolean;
  iconField?: string;
  searchQuery?: string;
  searchLoading?: boolean
}
interface Item {
  id: number | string;
  title?: string;
  name?: string;
  year?: string;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DropdownToggle',
  props: {
    data: {},
    idActive: {},
    isFilterAll: { type: Boolean },
    isSearchAll: { type: Boolean },
    iconField: {},
    searchQuery: {},
    searchLoading: { type: Boolean }
  },
  emits: ["handleChoose", "handleSearch"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;
const selectHeader = ref<HTMLElement | null>(null);
const selectContent = ref<HTMLElement | null>(null);
const itemActive = ref<Item | null>(
  props.idActive
    ? props.data.find((item: any) => item.id === props.idActive)
    : null
);
const isShow = ref(false);

const dataFilterAll = computed(() => {
  if (props.isFilterAll) {
    return [{ id: "", name: "Tất cả" }, ...props.data];
  }

  return props.data;
});

const handleToggle = () => {
  isShow.value = !isShow.value;
};
const handleChoose = (item: Item) => {
  itemActive.value = item;
  isShow.value = false;

  emits("handleChoose", item);
};

const handleSearch = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;

  emits("handleSearch", value);
};

const closeCountrySelect = () => {
  isShow.value = false;
};

const getName = (item: Item) => {
  return item.name ?? item.year ?? item.title;
};

useClickOutside([selectHeader, selectContent], {
  handler: closeCountrySelect,
  middleware: (event) => {
    const target = event.target as HTMLElement;

    if (target.closest(".icon-arrow")) {
      return false;
    }

    return true;
  },
});

return (_ctx: any,_cache: any) => {
  return (dataFilterAll.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "as-dropdown-toggle__select__as-head",
            onClick: handleToggle,
            ref_key: "selectHeader",
            ref: selectHeader
          }, [
            (_ctx.iconField && itemActive.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getImgUrlBySport(_ctx.iconField, itemActive.value.id),
                  alt: getName(itemActive.value)
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(itemActive.value && itemActive.value?.id
            ? getName(itemActive.value)
            : "Tất cả"), 1),
            (!isShow.value)
              ? (_openBlock(), _createBlock(IconCustomArrownDown, {
                  key: 1,
                  fill: "#2FB925",
                  onClick: _withModifiers(handleToggle, ["stop"])
                }))
              : (_openBlock(), _createBlock(IconCustomArrownUp, {
                  key: 2,
                  fill: "#2FB925",
                  onClick: _withModifiers(handleToggle, ["stop"])
                }))
          ], 512),
          (isShow.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "as-dropdown-toggle__select__as-body",
                ref_key: "selectContent",
                ref: selectContent
              }, [
                (_ctx.isSearchAll)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("input", {
                        name: "search",
                        placeholder: "Tìm kiếm...",
                        onInput: handleSearch,
                        value: _ctx.searchQuery
                      }, null, 40, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                (!!dataFilterAll.value?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(dataFilterAll.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["as-item-dropdown", {
            'as-active': _ctx.idActive === item.id
          }]),
                        onClick: ($event: any) => (handleChoose(item))
                      }, [
                        (_ctx.iconField)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getImgUrlBySport(_ctx.iconField, item.id),
                              alt: getName(item)
                            }, null, 8, _hoisted_7))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(getName(item)), 1)
                      ], 10, _hoisted_6))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_ctx.isSearchAll && _ctx.searchLoading)
                        ? (_openBlock(), _createBlock(Loading, {
                            key: 0,
                            iconOnly: ""
                          }))
                        : (_openBlock(), _createBlock(NoData, {
                            key: 1,
                            title: "Không tìm thấy dữ liệu"
                          }))
                    ]))
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})